import $ from 'jquery';

const setFixedMenu = (_scroll) => {
  $('.header-pc').toggleClass('is-fixedHeader', _scroll > 110);
};

const setSpMenu = (MYAPP) => {
  $('.header-sp .gNaviButton').off().on('click', function(event){
    event.preventDefault();
    const activeCls = 'active';
    if ($(this).hasClass(activeCls)) {
      unsetFixedScroll(MYAPP.scrollpos);
    } else {
      setFixedScroll(MYAPP,$(window).scrollTop());
    }
    $(this).toggleClass(activeCls);
    $('.header-sp .gNaviBody').stop(true,true).slideToggle();
  });
};

const setPcMenu = (MYAPP) => {
  if (!MYAPP.ua.isTablet) {
    setMegaMenuFirst(MYAPP);
  } else {
    setMegaMenuFirstTablet(MYAPP);
  }
  setMegaMenuSecond();
};

const setMegaMenuSecond = () => {
  $('.js-changeMegaMenuSecond').on('click',function(event){
    event.preventDefault();
  }).hover(function(){
    const $this = $(this),
          id    = $(this).children('a').attr('href'),
          activeCls = 'is-active';
    $this.addClass(activeCls).siblings().removeClass(activeCls);
    $(id).show().siblings().hide();
  },function(){
    return false;
  });
};

const setMegaMenuFirst = (MYAPP) => {
  $('.js-changeMegaMenuFirst').on('click',function(event){
    event.preventDefault();
  }).hover(function(){
    openMegaMenu(MYAPP,$(this));
  }, function(){
    closeMegaMenu(MYAPP,$(this));
  });
};

const openMegaMenu = (MYAPP,$this) => {
  const id        = $this.children('a').attr('href'),
        $id       = $(id),
        activeCls = 'is-active';
  let windowScrollTop = 0;
  if ($('body')[0].hasAttribute('style')) {
    windowScrollTop = MYAPP.scrollpos;
  } else {
    windowScrollTop = $(window).scrollTop();
  }
  setFixedScroll(MYAPP,windowScrollTop);
  if (MYAPP.scrollpos > 110) {
    $('.header-pc').addClass('is-fixedHeader-openedMegaMenu');
  }
  $this.addClass(activeCls).siblings().removeClass(activeCls);
  setShowMegaMenu($id);
};

const closeMegaMenu = (MYAPP,$this) => {
  const id  = $this.children('a').attr('href'),
        $id = $(id);
  let setClose = null;
  const close = ()=> {
    unsetFixedScroll(MYAPP.scrollpos);
    if (MYAPP.scrollpos > 110) {
      $('.header-pc').removeClass('is-fixedHeader-openedMegaMenu');
    }
    $this.removeClass('is-active');
    setHideMegaMenu($id);
  };
  $('.megaMenu_first').hover(function(){
    clearTimeout(setClose);
    $(this).find('.megaMenu_close').on('click', function(event){
      event.preventDefault();
      close();
    });
  }, function(){
    close();
  });
  setClose = setTimeout(function(){
    close();
  },100);
};

const setMegaMenuFirstTablet = (MYAPP) => {
  $('.js-changeMegaMenuFirst a').off().on('click',function(event){
    event.preventDefault();
    const $this     = $(this).parent(),
          id        = $(this).attr('href'),
          $id       = $(id),
          activeCls = 'is-active';
    const close = () => {
      unsetFixedScroll(MYAPP.scrollpos);
      if (MYAPP.scrollpos > 110) {
        $('.header-pc').removeClass('is-fixedHeader-openedMegaMenu');
      }
      $this.removeClass(activeCls);
      setHideMegaMenu($id);
    };
    if (!$this.hasClass(activeCls)) {
      setFixedScroll(MYAPP,$(window).scrollTop());
      if (MYAPP.scrollpos > 110) {
        $('.header-pc').addClass('is-fixedHeader-openedMegaMenu');
      }
      $this.addClass(activeCls).siblings().removeClass(activeCls);
      setShowMegaMenu($id);
      setHideMegaMenu($id.siblings());
    } else {
      close();
    }
    $id.find('.megaMenu_close').off().on('click', function(event){
      event.preventDefault();
      close();
    });
  });
};

const setFixedScroll = (MYAPP,scrollpos) => {
  MYAPP.scrollpos = scrollpos;
  $('body').css( {
    position: 'fixed',
    width: '100%',
    top: -1 * MYAPP.scrollpos
  } );
};

const unsetFixedScroll = (scrollpos) => {
  $('body').removeAttr('style');
  window.scrollTo(0 , scrollpos);
};

const setShowMegaMenu = ($el) => {
  $el.css({
    'opacity': 1,
    'z-index': 2,
    'visibility': 'visible',
    'transform' : 'translate3d(0,0,0)'
  }).off().on('transitionend', function(){
    $el.css({
      'visibility': 'visible'
    });
  });
};

const setHideMegaMenu = ($el) => {
  $el.css({
    'opacity': 0,
    'z-index': 1,
    'transform' : 'translate3d(0,-10px,0)'
  }).off().on('transitionend', function(){
    $el.css({
      'visibility': 'hidden'
    });
  });
};

module.exports = {
  setSpMenu      : setSpMenu,
  setPcMenu      : setPcMenu,
  setFixedMenu   : setFixedMenu,
};



// WEBPACK FOOTER //
// ./src/js/modules/header.js